import React from 'react';

import Content from '@components/Dashboard/AdminPanel/PushNotification';

const PushNotification: React.FC = () => {
  return <Content />;
};

export default PushNotification;
